export default {
  computed: {
    userIsCgElite () {
      return this.$store.state.header?.headerData?.isElite ?? false
    }
  }
}
